import { render, staticRenderFns } from "./NotificationsSetupChoice.vue?vue&type=template&id=20f5d371&scoped=true"
import script from "./NotificationsSetupChoice.js?vue&type=script&lang=js&external"
export * from "./NotificationsSetupChoice.js?vue&type=script&lang=js&external"
import style0 from "./NotificationsSetupChoice.scss?vue&type=style&index=0&id=20f5d371&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5d371",
  null
  
)

export default component.exports